const IsNullOrEmpty = (variable) => {
    if (variable === null) return true;
    return variable.length === 0;
};

export default IsNullOrEmpty;
